var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ResizableContent",
    {
      staticClass: "conversations",
      attrs: {
        handles: ["mr"],
        onResize: _vm.onResizeConversations,
        "max-width": _vm.maxGridConversationsWidth,
        "min-width": _vm.minGridConversationsWidth,
        width: _vm.width,
      },
    },
    [
      _c("GridContactListToolBar"),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "conversationsList",
          staticClass: "conversation-lists",
          on: { scroll: _vm.scrollListener },
        },
        [
          _vm._l(_vm.contacts, function (c) {
            return _c("GridContactListItem", {
              key: c._id + "-" + _vm.selectedSortField,
              ref: "contact-" + c._id,
              refInFor: true,
              attrs: {
                contact: c,
                activeContact: _vm.contact,
                currentTime: _vm.currentTime,
              },
              on: {
                joinConversation: function ($event) {
                  return _vm.joinConversation(c._id)
                },
                "show-context-menu": _vm.onShowContextMenu,
              },
            })
          }),
          _vm._v(" "),
          _vm.contacts.length <= 0
            ? _c("div", { staticClass: "empty-conversations" }, [
                _c(
                  "div",
                  { staticClass: "empty-conversations-content" },
                  [
                    _c("EmptyChatList"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "empty-conversations-content-title" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "chat.gridContactList.emptyConversationsTitle"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "empty-conversations-content-description",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(
                                "chat.gridContactList.emptyConversationsDescription"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "empty-conversations-content-action" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "" },
                            on: { click: _vm.forwardCustomerUrl },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.customerPage")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loading-dots-container" }, [
                _c("div", { staticClass: "loading-dots" }, [
                  _c("div", { staticClass: "dot" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dot" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dot" }),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("ContextMenu", {
        attrs: {
          visible: _vm.contextMenu.visible,
          x: _vm.contextMenu.x,
          y: _vm.contextMenu.y,
          items: _vm.contextMenuItems,
        },
        on: { "item-click": _vm.onContextMenuItemClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }